export const PUBLISHER_ID = process.env.REACT_APP_PUBLISHER_ID || '997898567'
export const NODE_ENV = process.env.REACT_APP_ENV_APP || 'sandbox';
export const ENABLED_MULTIPLE_LANGUAGE = process.env.ENABLED_MULTIPLE_LANGUAGE === "true" || false;
export const API_URL = NODE_ENV === 'production' ? 'https://mediastoreapi.cleeng.com' : 'https://mediastoreapi-sandbox.cleeng.com'
export const REACT_APP_EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
export const REACT_APP_EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
export const REACT_APP_PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY || "";